module.exports = __webpack_public_path__ + "static/20-d0d5af5590cf455ae52293d41a5e3ab2.jpg";